<template>
  <div :class="['default-header-container']">
    <nav class="navbar navbar-expand-lg navbar-light navbar-default-header">
      <div class="default-header-input-container form-group">
        <div :class="componentStyle.header + '-header'">
          <img
            src="../assets/img/headerInfos/img.jpg"
            class="default-header-image"
            alt="Default Image"
          />
        </div>
      </div>
    </nav>
    <div class="header-title">
      <div class="header-title__welcome">
        <i class="fo-icon-home"></i>
        <span class="header-title__welcome--size">{{ $t('default-header.welcome') }}</span>
      </div>
      <div class="header-title__description">
        <span class="header-title__description--title">{{ $t('default-header.title') }}</span>
        <span>{{ $t('default-header.description') }}</span>
      </div>
    </div>
    <div class="default-header-image2">
      <img
        src="../assets/img/headerInfos/illustration.svg"
        class="default-header-image"
        alt="Default Image"
      />
    </div>
    <div class="header-default-info" :class="{ 'side-nav': isSideNav }">
      <div
        :class="[
          'desktop-header d-none d-lg-block ',
          { 'header-background': isHeaderInfo },
          { 'header-margin': currentTheme > 0 },
          {
            ['header-default-content']: currentTheme === 0,
          },
        ]"
      >
        <header-info></header-info>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import SearchBar from '~/node_modules/search-bar/src/components/Component.vue';
import ListItems from '~/node_modules/list-items/src/components/Component.vue';
import Mixin from '@/mixins/Mixin';
import HeaderInfo from './HeaderInfo';

import HasPermission from '../directives/HasPermission.js';
export default {
  name: 'DefaultHeaderInfo',
  components: {
    SearchBar,
    ListItems,
    HeaderInfo,
  },
  mixins: [Mixin],
  watch: {
    keyword(newVal) {
      this.title = newVal;
    },
  },
  computed: {
    ...mapGetters({
      componentStyle: 'layout/getComponentStyle',
      currentTheme: 'videos/getCurrentTheme',
    }),
  },
  methods: {
    setPositionDefaultHeader() {
      var header = document.querySelector('.default-header-container');
      var headerInfo = document.querySelector('.header-default-info');
      var headerTitle = document.querySelector('.header-title');
      var mobileHeader = document.querySelector('.mobile-header');
      var welcome = document.querySelector('.header-title__welcome');
      let scrollPosition = Math.round(window.scrollY);
      if (header) {
        let headerHeight = header.offsetHeight;

        let headerInfoHeight = headerInfo.offsetHeight;
        let mobileHeaderHeight = mobileHeader.offsetHeight;
        let scrollSize = headerHeight - headerInfoHeight;
        let { display } = window.getComputedStyle(mobileHeader);
        if (display === 'block') {
          scrollSize -= mobileHeaderHeight;
        }
        let mobileVersion = window.innerWidth;
        if (headerInfo) {
          if (scrollPosition > scrollSize) {
            headerInfo.classList.add('default-desktop-header');
            headerTitle.classList.add('position-scroll');
            welcome.classList.add('position-scroll');
            if (mobileVersion <= 992) {
              headerTitle.classList.add('mobile-version');
              headerInfo.classList.add('mobile-version');
            } else {
              headerTitle.classList.remove('mobile-version');
              headerInfo.classList.remove('mobile-version');
            }
          } else {
            headerInfo.classList.remove('default-desktop-header');
            headerTitle.classList.remove('position-scroll');
            welcome.classList.remove('position-scroll');
            if (mobileVersion <= 992) {
              headerTitle.classList.remove('mobile-version');
              headerInfo.classList.remove('mobile-version');
            }
          }
        }
      }
    },
  },
  created() {},
  mounted() {
    let self = this;
    window.addEventListener('scroll', function() {
      self.setPositionDefaultHeader();
    });
    window.addEventListener('resize', function() {
      self.setPositionDefaultHeader();
    });
  },
};
</script>
<style lang="scss">
.default-header-container {
  width: 100%;
  margin: 0;
  position: relative;
  .navbar-default-header {
    padding: 0 !important;
    .default-header-input-container {
      display: flex;
      flex-direction: column;
      font-size: 1em;
      color: #fff;
      width: 100%;
      justify-content: flex-start;
      padding: 0;
      text-align: center;
      margin: 0;
      .info-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 0;
        .default-header-image {
          display: block;
          width: 100%;
          background-size: 50% 50%;
          background: no-repeat center;
          height: 355px;
        }
      }
    }
  }
  .header-title {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 18%;
    padding: 0 0 0 2em;
    width: 100%;
    @media screen and (max-width: 768px){
      width: 50%;
      padding: 0 0 0 1em;
    }
    @media screen and (max-width: 480px){
      width: 45%;
      padding: 0 0 0 0.5em;
    }

    &.position-scroll {
      position: fixed;
      top: 0;
      left: 17%;
      padding: 1.2em 2em;
      z-index: 1003;
      &.mobile-version {
        top: 60px;
        left: 0 !important;
        width: 100%;
        z-index:3;
      }
    }

    &__welcome {
      color: var(--primary-color);
      display: flex;
      flex-direction: row;
      align-items: center;
      &.position-scroll {
        color: white;
      }
      &--size {
        margin: 0;
        font-size: 1.2em;
        font-weight: bold;
        padding: 0 0.5em;
      }
    }
    &__description {
      font-size: 0.8em;
      color: var(--secondary-color);
      &--title {
        font-weight: bold;
      }
    }
  }
  .default-header-image2 {
    position: absolute;
    top: 0;
    right: 3%;
    z-index: 1;
    padding: 0;
      @media screen and (max-width: 768px){
          right: 0;
      }
  }

  .header-default-content {
    &.mobile-header {
      height: 30%;
    }
  }
  .header-default-info {
    position: absolute;
    width: 100%;
    height: 40%;
    bottom: 0;
    background: var(--primary-color);
    &.default-desktop-header {
      position: fixed;
      height: 100px;
      top: 0;
      z-index: 2; // Player control-bar
      //margin: 0 -15px;
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05), inset 0 -1px 0 rgba(0, 0, 0, 0.1);
    }
    &.mobile-version {
      position: fixed;
      height: 100px;
      top: 57px;
    }
  }
}
@media (max-width: 992px) {
  .default-header-container {
    top: 60px;
    .header-default-info {
      height: 30%;
    }
    .navbar-default-header {
      padding: 0 !important;
      .default-header-input-container {
        .info-header {
          .default-header-image {
            height: 310px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DefaultHeaderInfo.vue